import React, { useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

/**
 * One-tap rebook button for completed bookings. Server side (POST /bookings/{id}/rebook)
 * creates a new payment_pending booking cloning service/address/instructions and
 * schedules it 7 days out at 10:00 local time.
 */
export default function RebookButton({ booking, testId }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!booking?.id || booking.status !== "completed") return null;

  const rebook = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setBusy(true);
    try {
      const scheduled = new Date();
      scheduled.setDate(scheduled.getDate() + 7);
      scheduled.setHours(10, 0, 0, 0);
      const { data } = await api.post(`/bookings/${booking.id}/rebook`, {
        scheduled_start: scheduled.toISOString(),
      });
      toast.success("New booking created — head over to pay & confirm.");
      if (data?.id) nav(`/dashboard/bookings/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.error || "Could not rebook");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={rebook}
      disabled={busy}
      data-testid={testId || `rebook-btn-${booking.id}`}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#165a71]/30 bg-white px-3 py-1.5 text-xs font-medium text-[#165a71] hover:bg-[#165a71]/5 transition-colors disabled:opacity-50"
    >
      <RotateCcw className="h-3.5 w-3.5" /> {busy ? "Booking…" : "Rebook"}
    </button>
  );
}
